<template>
    <div class="basicData" v-wechat-title="$t('区域信息管理')">
        <Title :title="$t('区域信息管理')"/>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('事业部') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.parameters.enterpriseId" clearable :placeholder="$t('请选择')" @change="getOrganizationListAll(2, $event)">
                            <el-option v-for="item in listOne" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('应用中心') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.parameters.centerId" clearable :placeholder="$t('请选择')" @change="getOrganizationListAll(3, $event)">
                            <el-option v-for="item in listTwo" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('服务区域') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.parameters.areaId" clearable :placeholder="$t('请选择')">
                            <el-option v-for="item in listThree" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('国家') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.parameters.countryId" :placeholder="$t('请选择')" @change="divisionList(2, $event)">
                            <el-option v-for="item in listFour" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('省份') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.parameters.provinceId" clearable :placeholder="$t('请选择')" @change="divisionList(3, $event)">
                            <el-option v-for="item in listFive" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('城市') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.parameters.prefectureId" clearable :placeholder="$t('请选择')" @change="divisionList(4, $event)">
                            <el-option v-for="item in listSix" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('区县') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.parameters.countyId" clearable :placeholder="$t('请选择')">
                            <el-option v-for="item in listSeven" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span></span></div>
                    <div class="input_box">

                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span></span></div>
                    <div class="input_box"></div>
                </div>
            </div>
        </div>
        <div class="btn_box">
            <button type="button" class="search_btn" @click="search">{{ $t('查询') }}</button>
            <button type="button" class="delete_btn" @click="deleteList" v-permissions="26010405">{{ $t('删除') }}</button>
            <button type="button" class="add_btn" @click="add" v-permissions="26010403">{{ $t('添加') }}</button>
        </div>
        <div class="table_box">
            <el-table :data="list" v-loading="loading" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column :label="$t('服务区域')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.areaName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('国家')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.countryName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('省份')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.provinceName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('城市')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.prefectureName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('区县')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.countyName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('应用中心')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.centerName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('区域负责人')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.managerName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" align="center">
                    <template slot-scope="scope">
                        <div class="table_btn_box">
                            <span class="table_btn edit" :title="$t('编辑')" @click.stop="edit(scope.row)"></span>
                            <span class="table_btn delete" :title="$t('删除')" @click.stop="deleteItem(scope.row)" v-permissions="26010404"></span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_box">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="10"
                    :current-page="parameters.page"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageInfo.total">
            </el-pagination>
        </div>
        <Dialog v-if="isShow" :message="message" @cancel="isShow = false" @sure="sureDelete"/>
    </div>
</template>

<script>
    export default {
        name: 'keep-alive',
        data () {
            return {
                message: '',
                isShow: false,
                loading: false,
                list: [],
                pageInfo: {
                    total: 0
                },
                parameters: {
                    page: 1,
                    rows: 10,
                    parameters: {
                        enterpriseId: '',
                        centerId: '',
                        areaId: '',
                        countryId: 0,
                        provinceId: '',
                        prefectureId: '',
                        countyId: ''
                    }
                },
                listOne: [],
                listTwo: [],
                listThree: [],
                listFour: [],
                listFive: [],
                listSix: [],
                listSeven: [],
                deleteId: '',
                deleteIdList: '',
                deleteWho: 1
            }
        },
        mounted () {
            this.initMounted()
        },
        activated () {
            this.getList()
        },
        methods: {
            initMounted () {
                for (let level = 1; level <= 3; level++) {
                    this.getOrganizationListAll(level)
                }
                this.divisionList(1, -1)
                this.divisionList(2, 0)
                this.getList()
            },
            search () {
                this.parameters.page = 1
                this.getList()
            },
            add () {
                this.$router.push('/maintainAreaInfoAddOrEdit')
            },
            edit (item) {
                this.$router.push({
                    path: '/maintainAreaInfoAddOrEdit',
                    query: {
                        id: item.id
                    }
                })
            },
            handleSelectionChange (value) {
                let idList = []
                for (let item of value) {
                    idList.push(item.id)
                }
                this.deleteIdList = idList.join()
            },
            deleteList () {
                if (!this.deleteIdList) {
                    this.$message.info(this.$t('请先选择后再删除'));
                    return false
                }
                this.message = this.$t('删除后无法恢复，确认删除选择的记录吗')
                this.deleteWho = 2
                this.isShow = true
            },
            deleteItem (item) {
                this.message = this.$t('删除后无法恢复，确认删除该条记录')
                this.deleteWho = 1
                this.deleteId = item.id
                this.isShow = true
            },
            sureDelete () {
                if (this.deleteWho === 1) {
                    this.$store.dispatch('a:maintainAreaInfo/delete', {id: this.deleteId}).then(
                        res => {
                            if (this.pageInfo.isLastPage && this.list.length === 1 && this.parameters.page > 1) {
                                this.parameters.page--
                            }
                            this.getList()
                            this.isShow = false
                            this.deleteId = ''
                        },
                        rej => {
                            this.isShow = false
                            this.$message({
                                type: 'error',
                                dangerouslyUseHTMLString: true,
                                message: rej.errorInfo
                            });
                        }
                    )
                } else {
                    this.$store.dispatch('a:maintainAreaInfo/deleteAll', {ids: this.deleteIdList}).then(
                        res => {
                            if (this.pageInfo.isLastPage && this.list.length === this.deleteIdList.split(',').length && this.parameters.page > 1) {
                                this.parameters.page--
                            }
                            this.$message.success(`${ this.$t('成功删除') } ${ this.deleteIdList.split(',').length } ${ this.$t('条数据') }`)
                            this.getList()
                            this.isShow = false
                            this.deleteIdList = ''
                        },
                        rej => {
                            this.isShow = false
                            this.$message({
                                type: 'error',
                                dangerouslyUseHTMLString: true,
                                message: rej.errorInfo
                            });
                        }
                    )
                }
            },
            handleSizeChange (val) {
                this.parameters.rows = val
                this.getList()
            },
            handleCurrentChange (val) {
                this.parameters.page = val
                this.getList()
            },
            getList () {
                this.loading = true
                this.$store.dispatch('a:maintainAreaInfo/getList', this.parameters).then(
                    res => {
                        this.list = res.list || []
                        this.pageInfo = res.pageInfo
                        this.loading = false
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                        this.loading = false
                    }
                )
            },
            getOrganizationListAll (level, parentId) {
                if (level === 2) {
                    // if (parentId === '') {
                    //     this.parameters.parameters.centerId = this.parameters.parameters.areaId = ''
                    //     this.getOrganizationListAll(3, '')
                    // }
                    this.parameters.parameters.centerId = this.parameters.parameters.areaId = ''
                    this.getOrganizationListAll(3, '')
                } else if (level === 3) {
                    if (parentId === '') {
                        this.parameters.parameters.areaId = ''
                    }
                }
                this.$store.dispatch('a:common/getOrganizationListAll', {
                    level: level,
                    parentId: parentId
                }).then(
                    res => {
                        switch (level) {
                            case 1:
                                this.listOne = res
                                break;
                            case 2:
                                this.listTwo = res
                                break;
                            case 3:
                                this.listThree = res
                                break;
                        }
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            divisionList (level, id) {
                if (level === 3) {
                    this.parameters.parameters.prefectureId = this.parameters.parameters.countyId = ''
                    this.listSix = this.listSeven = []
                    if (id === '') return false
                } else if (level === 4) {
                    this.parameters.parameters.countyId = ''
                    this.listSeven = []
                    if (id === '') return false
                }
                this.$store.dispatch('a:maintainAreaInfo/divisionList', {
                    parentId: id
                }).then(
                    res => {
                        switch (level) {
                            case 1:
                                this.listFour = res
                                break;
                            case 2:
                                this.listFive = res
                                break;
                            case 3:
                                this.listSix = res
                                break;
                            case 4:
                                this.listSeven = res
                                break;
                        }
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
